
<template>
  <div>
    <v-dialog
      v-model="task_all_status_list_popup"
      persistent
      max-width="1150px"
      max-height="800px !important"
      internal-activator
    >
      <v-card tile :loading="task_list_loading">
        <v-card-title class="pa-0">
          <v-row dense no-gutters>
            <v-col class>
              <v-card-title class="pa-0">
                <v-col cols="5" class="d-flex p-0"></v-col>
                <v-col cols="3">Status List</v-col>
                <v-col cols="4">
                  <v-tooltip bottom v-if="selectedRows2.length > 0">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        fab
                        x-small
                        color="error"
                        v-bind="attrs"
                        v-on="on"
                        @click="deleteDocuments"
                      >
                        <v-icon>mdi-delete-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Remove Document(s)</span>
                  </v-tooltip>
                  <v-menu
                    bottom
                    :close-on-content-click="false"
                    content-class="elevation-0"
                    v-model="filter_menu"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn size="22px" icon v-bind="attrs" v-on="on" class="ml-5 header_btn">
                        <v-icon size="22px" color>mdi-filter-menu-outline</v-icon>
                        <span class="lable_class">Filter</span>
                      </v-btn>
                    </template>
                    <v-card tile max-width="310" class="mb-5 mr-5">
                      <v-list class="filter-section-border">
                        <v-list-item>
                          <v-autocomplete
                            dense
                            :items="status_list"
                            v-model="pagination.filters.status"
                            item-text="status"
                            item-value="task_status"
                            outlined
                            hide-details
                            clearable
                            label="status"
                          ></v-autocomplete>
                        </v-list-item>
                      </v-list>
                      <v-card-title class="pa-0">
                        <v-btn
                          fab
                          color="error"
                          x-small
                          absolute
                          @click="filter_menu = false"
                          class="custom-close-btn"
                        >
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </v-card-title>
                    </v-card>
                  </v-menu>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                        @click="openDocList(selectedRows2[0])"
                        class="ml-6 header_btn"
                        :disabled="selectedRows2.length == 0 ||  selectedRows2.length > 1"
                      >
                        <span class="lable_class">Documents</span>
                        <v-badge
                          color="error"
                          :content="(selectedRows2[0] && selectedRows2.length == 1)?selectedRows2[0].document_count:''"
                          :value="(selectedRows2[0] && selectedRows2.length == 1)?selectedRows2[0].document_count:''"
                          overlap
                        >
                          <v-icon size="28px">mdi-dresser-outline</v-icon>
                        </v-badge>
                      </v-btn>
                    </template>
                    <span>Documents</span>
                  </v-tooltip>
                </v-col>
              </v-card-title>
            </v-col>
            <v-col cols="1" class="mt-2" style="max-width: 4%">
              <v-icon size="30" class="m drag-icon">mdi-drag-variant</v-icon>
            </v-col>
            <v-col cols="1" class="mt-2" style="max-width: 5%">
              <v-btn
                fab
                color="error"
                x-small
                @click="closeTaskAllStatusListPopup()"
                class="custom-close-btn"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text
          class="pa-1 mx-auto"
          style="
            overflow: auto !important;
            max-height: 584px !important;
            min-height: 584px !important;
          "
        >
          <v-data-table
            :headers="headers"
            class="elevation-1 rounded-0 my-transaction-table document-list"
            :items="task_items.data"
            dense
            item-key="doc_id"
            :server-items-length="task_items.total"
            :options.sync="pagination"
            mobile-breakpoint="50"
            :footer-props="{
              'items-per-page-options': pagination_settings.perPageList,
            }"
          >
            <!-- <template v-slot:item.edit="{ item }" class="td">
              <v-icon @click="addCalendarTaskModal(item.c_task_id)">
                mdi-clipboard-edit-outline
              </v-icon>
            </template>-->
            <template v-slot:item.checkbox="{ item }" class="td">
              <v-simple-checkbox v-model="item.selected" :ripple="false"></v-simple-checkbox>
            </template>
            <!-- <template v-slot:item.edit="{ item }" class="td">
              <v-icon
                class="mr-2"
                @click="addCalendarTaskModal(item.c_task_id, item.unique_id)"
              >mdi-clipboard-edit-outline</v-icon>
            </template>-->

            <template
              v-slot:item.created_at="{ item }"
              class="td"
            >{{ displayDateTimeFormate(item.created_at, "date") }}</template>
            <template
              v-slot:item.start_date="{ item }"
              class="td"
            >{{ displayDateTimeFormate(item.start_date, "date") }}</template>
            <template
              v-slot:item.end_date="{ item }"
              class="td"
            >{{ displayDateTimeFormate(item.end_date, "date") }}</template>
            <template v-slot:item.info="{ item }" class="td">
              <v-tooltip right max-width="400">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    :color="item.task_note ? 'green' : ''"
                    @click="update_task_note_modal=true;modal_task_id=item.c_task_id;modal_task_note=item.task_note;"
                  >mdi-note-text-outline</v-icon>
                </template>
                <span>{{item.task_note}}</span>
              </v-tooltip>
              <v-tooltip right max-width="400">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    height="20"
                    variant="text"
                    width="20"
                    border
                    v-if="item.task_status==5"
                    :style="{ backgroundColor: '#fca506',color:'#000000', marginLeft:'10px',minWidth:'10px !important'}"
                  >
                    <span style="font-size:12px !important;">{{item.delay_days}}</span>
                  </v-btn>
                </template>
                <span style="white-space: nowrap !important;">Delay Days</span>
              </v-tooltip>
              <v-tooltip right max-width="400">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    height="20"
                    variant="text"
                    width="20"
                    border
                    v-if="item.task_status==5"
                    :style="{ backgroundColor: '#a61f38',color:'#000000', marginLeft:'10px',minWidth:'10px !important'}"
                  >
                    <span style="font-size:12px !important;">{{item.ext_delay_days}}</span>
                  </v-btn>
                </template>
                <span style="white-space: nowrap !important;">Extension Delay Days</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="update_task_note_modal" persistent max-width="500px">
      <v-card :loading="update_task_loading">
        <v-card-title>
          <span class="headline">Update Task Note</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-textarea dense hide-details v-model="modal_task_note" outlined rows="3"></v-textarea>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="update_task_note_modal = false;">Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" :loading="update_task_loading" @click="UpdateTasknote()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "../../plugins/axios";
import { mapState, mapMutations, mapActions } from "vuex";
import { parseParams } from "../../plugins/helper";
const moment = require("moment");
export default {
  name: "TaskList",
  data: () => ({
    headers: [
      {
        value: "checkbox",
        text: "#",
        sortable: false,
        width: "2%",
        align: "center"
      },

      {
        value: "task.task",
        text: "Task",
        sortable: false,
        width: "27%",
        align: "center"
      },
      {
        value: "start_date",
        text: "St. Dt.",
        sortable: false,
        width: "10%",
        align: "center"
      },
      {
        value: "working_days",
        text: "W.Days",
        sortable: false,
        width: "5%",
        align: "center"
      },
      {
        value: "end_date",
        text: "Comp. Dt.",
        sortable: true,
        width: "15%",
        align: "center"
      },
      {
        value: "status",
        text: "Status",
        sortable: false,
        width: "10%",
        align: "center"
      },
      {
        value: "created_at",
        text: "Entry Date",
        sortable: false,
        width: "10%",
        align: "center"
      },
      {
        value: "user.first_name",
        text: "User",
        sortable: false,
        width: "10%",
        align: "center"
      },
      {
        value: "info",
        text: "Info",
        sortable: false,
        width: "20%",
        align: "left"
      }

      // {
      //   value: "task_order",
      //   text: "Task Order",
      //   sortable: false,
      //   width: "15%",
      // },
      // { value: "user.first_name", text: "User", sortable: false, width: "15%" },
      // { value: "action", text: "View", sortable: false, width: "7.5%" },
    ],
    search: "",
    task_list_loading: false,
    task_items: [],
    update_task_note_modal: false,
    update_task_loading: false,
    modal_task_id: "",
    modal_task_note: "",
    filter_menu: false,
    pagination: {
      itemsPerPage: 20,
      sortBy: ["c_task_id"],
      page: 1,
      search: "",
      filters: {
        status: "all"
      }
    },
    status_list: []
    // status_list: [
    //   {
    //     text: "Open",
    //     value: "1",
    //     children: []
    //   },
    //   {
    //     text: "Schedule",
    //     value: "2"
    //   },
    //   {
    //     text: "Delay",
    //     value: "5"
    //   },
    //   {
    //     text: "Reschedule",
    //     value: "3"
    //   },
    //   {
    //     text: "Complete",
    //     value: "4"
    //   },
    //   {
    //     text: "All",
    //     value: "all"
    //   }
    // ]
  }),
  props: ["task_all_status_list_popup", "unique_id", "o_id"],
  watch: {
    task_all_status_list_popup: {
      handler(val) {
        if (val) {
          this.pagination.filters.status = "";
          this.getStatusListByProject(this.o_id, this.unique_id);
          this.getTaskAllStatusList(parseParams(this.pageData));
        }
      }
    },
    pagination: {
      handler() {
        this.getTaskAllStatusList(parseParams(this.pageData));
      },
      deep: true
    }
  },
  computed: {
    ...mapState("utils", ["pagination_settings"]),

    pageData() {
      let paginationData = this.pagination;
      return paginationData;
    },
    selectedRows2() {
      let returnData = [];
      if (this.task_items.data) {
        this.task_items.data.filter(function(item) {
          if (item.selected) {
            returnData.push(item);
          }
        });
      }
      return returnData;
    }
  },

  methods: {
    ...mapActions("task", ["getTasks", "getTotalTaskDays"]),
    ...mapMutations("addtask", ["setAddTaskData"]),
    ...mapMutations("document", ["setDocumentData"]),

    displayDateTimeFormate(date, flag) {
      if (flag == "time") {
        return moment(date).format("H:mm:ss");
      } else if (flag == "datetime") {
        return moment(date).format("MM/DD/YYYY H:mm");
      } else {
        return moment(date).format("MM/DD/YYYY");
      }
    },
    closeTaskAllStatusListPopup() {
      this.$emit("closeTaskAllStatusListPopup");
    },
    deleteDocuments() {
      let _self = this;
      let ids = [];
      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      this.selectedRows2.map(function(item) {
        ids.push(item.c_task_id);
      });
      if (ids.length > 0) {
        axios
          .post("calendar_task/delete", {
            ids: ids,
            company_id: company_data.company_id
          })
          .then(function() {
            _self.getTaskAllStatusList(parseParams(_self.pageData));
          })
          .catch(function() {
            console.log("FAILURE123!!");
          });
      }
    },
    cancelSearch() {
      if (this.cancelSource) {
        this.cancelSource.cancel("Start new search, stop active search");
        // console.log('cancel request done');
      }
    },
    getTaskAllStatusList(url) {
      let _self = this;
      var unique_id = _self.unique_id;
      this.cancelSearch();
      this.cancelSource = axios.CancelToken.source();
      axios
        .get(
          "calendar_task/get_all_status_list?unique_id=" +
            unique_id +
            "&" +
            url,
          { cancelToken: this.cancelSource.token }
        )
        .then(function(res) {
          if (res.data.status) {
            let data = res.data;
            _self.task_items = data.data;
          }
        })
        .catch(function() {
          console.log("FAILURE!!");
        });
    },
    getStatusListByProject(o_id, unique_id) {
      let _self = this;
      axios
        .get(
          "calendar_task/get_task_status_by_project?unique_id=" +
            unique_id +
            "&o_id=" +
            o_id
        )
        .then(function(res) {
          if (res.data.status) {
            let data = res.data;
            _self.status_list = data.data.data;
          }
        })
        .catch(function() {
          console.log("FAILURE!!");
        });
    },
    addCalendarTaskModal(c_task_id, unique_id) {
      this.setAddTaskData({ key: "p_id", value: this.o_id });
      this.setAddTaskData({ key: "type_module", value: 8 });
      this.setAddTaskData({ key: "c_task_id", value: c_task_id });
      this.setAddTaskData({ key: "unique_id", value: unique_id });
      this.setAddTaskData({ key: "add_calendar_task_modal", value: true });
    },

    openDocList(item) {
      this.setDocumentData({ key: "main_task_id", value: item.unique_id });
      this.setDocumentData({ key: "child_task_id", value: item.c_task_id });
      this.setDocumentData({ key: "doc_list_modal", value: true });
      this.setDocumentData({ key: "type", value: 8 });
      this.setDocumentData({ key: "o_id", value: item.o_id });
      this.setDocumentData({ key: "item", value: item });
      this.setDocumentData({ key: "form_name", value: "Calendar Task" });
      this.setDocumentData({ key: "item_name", value: "" });
      this.setDocumentData({ key: "job_name", value: "" });
      this.setDocumentData({ key: "user_name", value: "" });
      this.setDocumentData({ key: "customer_name", value: this.customer_name });
      this.setDocumentData({ key: "bank_name", value: "" });
      this.setDocumentData({ key: "project_name", value: this.project_name });
      this.setDocumentData({ key: "vendor_name", value: "" });
      this.setDocumentData({ key: "doc_module", value: "CALENDARTASK" });
      // this.$router.push({name: 'projects_document'});
    },
    UpdateTasknote() {
      let _self = this;
      axios
        .post("calendar_task/update_task_note", {
          task_id: _self.modal_task_id,
          task_note: _self.modal_task_note
        })
        .then(function(res) {
          if (res.data.status) {
            _self.getTaskAllStatusList(parseParams(_self.pageData));
            _self.update_task_loading = false;
            _self.update_task_note_modal = false;
          }
        })
        .catch(function() {
          console.log("FAILURE!!");
        });
    }
  }
};
</script>

<style scoped>
.theme--dark.v-tabs > .v-tabs-bar {
  background-color: #1e1e1e7a !important;
}
.header_btn {
  color: #757575 !important;
}
</style>